import React, { Fragment } from 'react';
import { observable } from 'mobx';
import { inject, Observer } from 'mobx-react';
import _ from 'lodash';

import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import {
  MessageBar,
  MessageBarType,
} from 'office-ui-fabric-react/lib/MessageBar';

import Loading from 'components/LoadingOverlay';

import { localizable } from 'components/Localization';

import BulkRegistrationTable from './BulkRegistrationTable';
import BulkRegistrationStore from './BulkRegistrationStore';
import BulkRegistrationPanelBase from './BulkRegistrationPanelBase';
import { getDefaultUploadTypes } from 'helpers/uploadTypes';

@inject('user', 'sale', 'inventory')
@localizable
class BulkRegistrationInventoryPanel extends BulkRegistrationPanelBase {
  @observable importing = false;
  @observable error = null;

  constructor(props) {
    super(props);
    const { user, sale, usedEmails, t } = this.props;
    this.store = new BulkRegistrationStore(
      user,
      sale,
      sale.round,
      usedEmails,
      t
    );
  }

  reset() {
    this.store.reset();
    this.importing = false;
    this.editing = false;
    this.error = null;
  }

  componentDidMount() {
    const { sale, inventory } = this.props;

    let contacts = null;
    try {
      const inviteStr = sessionStorage.getItem('invite');
      if (!!inviteStr) {
        contacts = JSON.parse(inviteStr).payload;
        sessionStorage.removeItem('invite');
      }
    } catch (e) {}

    // this.store = new BulkRegistrationStore(
    //   user,
    //   sale,
    //   sale.round,
    //   usedEmails,
    //   t
    // );
    this.reset();

    this.importing = true;
    inventory
      .listBuyers(sale.offerData.objectno, sale.root.saleId, contacts)
      .then(
        (data) => {
          this.importing = false;
          this.handleImported(data);
        },
        (error) => {
          this.importing = false;
          this.error = error;
        }
      );
  }

  handleImported = (data) => {
    const config = this.props.sale.root.saleConfig;

    this.store.clear();

    _.forEach(data, (item) => {
      const _item = {
        key: item.email,
        email: item.email,
        phone: item.phone,
        salutation: item.salutation,
        title: item.title, // "combobox" must be controlled component
        firstName: item.first_name,
        lastName: item.last_name,
        offerViewing: '',
        dob: item.dob,
        pob: item.pob,
        street: (item.address || {}).street,
        zip: (item.address || {}).zip,
        city: (item.address || {}).city,
        country: (item.address || {}).state,
        requiredUploads: getDefaultUploadTypes(
          config,
          this.props.sale.offerData
        ),
        integrations: item.integrations,
      };
      this.store.add(_item);
    });

    this.editing = true;
  };

  render() {
    const { t, title, usedEmails } = this.props;

    return (
      <Panel
        headerText={title}
        hasCloseButton={false}
        type={PanelType.smallFluid}
        isOpen={this.props.isOpen}
        onDismiss={this.handleClose}
        onRenderFooterContent={() => this.renderPanelFooterContent()}
        isFooterAtBottom={true}
        closeButtonAriaLabel="Close"
        styles={{
          content: {
            height: '100%',
            paddingBottom: '0',
          },
        }}
      >
        <Observer
          render={() => (
            <Fragment>
              <Loading
                label={`${t('Importing')}...`}
                fullscreen={false}
                isVisible={this.importing}
              />
              {!this.importing && (
                <Fragment>
                  {this.errors && (
                    <div className="ms-Grid">
                      <div
                        className="ms-Grid-row"
                        style={{ padding: '10px 0' }}
                      >
                        <div className="ms-Grid-col ms-sm12">
                          <MessageBar messageBarType={MessageBarType.error}>
                            {this.error}
                          </MessageBar>
                        </div>
                      </div>
                    </div>
                  )}
                  {this.editing && (
                    <Fragment>
                      {this.renderRegistrationResult()}
                      <BulkRegistrationTable
                        store={this.store}
                        usedEmails={usedEmails}
                      />
                    </Fragment>
                  )}
                </Fragment>
              )}
            </Fragment>
          )}
        />
      </Panel>
    );
  }
}

export default BulkRegistrationInventoryPanel;



// WEBPACK FOOTER //
// ./src/app/containers/Sale/OffersSection/BulkRegistration/BulkRegistrationInventoryPanel.jsx